import React, { useState, useEffect } from 'react';
import { ActivityIndicator, Text } from 'react-native';
import axios from "@Services/AxiosInstance";
import { ScoreDECard } from "@Components/FollowUp/ScoreDE/ScoreDECard";
import { userAtom } from "@Recoil/Atom/userAtom"
import { useRecoilValue } from "recoil"

export const ScoreDERadar = ({ route }) => {
  const user = useRecoilValue(userAtom)
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userId = user?.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/api/surveyGroupScore?userId=${userId}`);
        setApiResponse(response.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  if (loading) {
    return <ActivityIndicator size="large" />;
  }

  if (error) {
    return <Text>Erreur : {error}</Text>;
  }

  return <ScoreDECard data={apiResponse} />;
};
